// extracted by mini-css-extract-plugin
export default {"logo":"A50MSL","hide":"ZV5iuf"};